import { Tag } from 'antd';
import { sortBy } from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';

import ImageThumbnail from '../../components/ImageThumbnail';
import {
  ImageThumbnailFragment as Image,
  OrganizationLabelFragment as Organization,
  PermissionScope_enum,
  PropertyFeatureFlagLabelFragment as PropertyFeatureFlag,
  PropertyTableFragment,
} from '../../graphql/hasura/generated';
import { authentication } from '../../stores';
import { formatPhoneNumber, truncateText } from '../../utils';
import { OrganizationModel } from '../Organization/model';

import model from './model';

export const organizationColumn = model.createColumn<{ organization: Organization }>({
  filterOptions: {
    type: 'MODEL_SELECT',
    key: 'organizationId',
    model: OrganizationModel,
  },
  enabled: ({ currentPermissionScope }) => currentPermissionScope === PermissionScope_enum.GLOBAL,
  render: ({ organization }) => OrganizationModel.routes.renderRowLink(organization),
});

export const nameColumn = model.createColumn<{ name: string }>({
  dataIndex: 'name',
});

export const imageColumn = model.createColumn<{ name: string, image?: Image | null }>({
  title: 'Image',
  sorter: false,
  render: ({ name, image }) => <ImageThumbnail title={name} image={image} />,
  renderString: false,
});

export const supportPhoneNumberColumn = model.createColumn<{ supportPhoneNumber?: string | null }>({
  title: 'Support Phone Number',
  render: ({ supportPhoneNumber }) => formatPhoneNumber(supportPhoneNumber),
});

export const supportEmailColumn = model.createColumn<{ supportEmail?: string | null }>({
  dataIndex: 'supportEmail',
  render: ({ supportEmail }) => truncateText(supportEmail),
  renderString: ({ supportEmail }) => supportEmail || '',
});

export const timezoneColumn = model.createColumn<{ timezone: string }>({
  title: 'Timezone',
  filterOptions: {
    type: 'ENUM',
    enumTable: 'Timezone',
  },
  render: ({ timezone }) => timezone,
});

export const propertyFeatureFlagsColumn = model.createColumn<{
  propertyFeatureFlags: PropertyFeatureFlag[],
}>({
  title: 'Feature Flags',
  render: ({ propertyFeatureFlags }) => {
    const sortedFeatureFlags = sortBy(propertyFeatureFlags, pf => pf.featureFlag.name);

    return (
      <div>
        {sortedFeatureFlags.map(({ featureFlag }) => (
          <Tag key={featureFlag.name} style={{ marginBottom: '8px' }}>
            {featureFlag.name}
          </Tag>
        ))}
      </div>
    );
  },
});

export const addressColumn = model.createColumn<PropertyTableFragment>({
  dataIndex: 'address',
});

export const funnelCommunityIdColumn = model.createColumn<PropertyTableFragment>({
  title: 'Funnel Community ID',
  render: ({ propertyId, funnelCommunityId }) => {
    if (authentication.currentDataScope.permissionScope !== PermissionScope_enum.GLOBAL) {
      return funnelCommunityId; // No link
    }

    if (funnelCommunityId) {
      return (
        <Link
          to={`${model.routes.basePath}/funnel-appointments/${propertyId}`}
        >
          {funnelCommunityId}
        </Link>
      );
    }

    return null;
  },
});
